import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

//services
import { get } from "../../services/http";
import routeListen from "../../services/routeListen";

//interfaces
import { IBuild } from "../../interfaces/Build";
import { SliceStatus } from "../../interfaces/Redux";
import { initialBuildState } from "../intialState/build";
import tokenStorageService from "../../services/TokenStorageService";

export interface BuildState {
  build: IBuild;
  status: SliceStatus;
  error?: string | undefined;
}
const initialState: BuildState = {
  build: initialBuildState,
  status: SliceStatus.initial,
  error: "",
};

let lastFetchUrl: string | undefined;
let lastFetchData: any;

export const fetchBuild = createAsyncThunk("build/fetchBuild", async (cacheBust?:boolean) => {

  let buildData: any  
  //if there is a stored orgShortName, we prioritise using it for fetching builds
  const orgShortName = tokenStorageService.getItem("orgShortName");
  const fetchUrl = orgShortName ? 
  `api/build/${orgShortName}` : 
  `api/build/${routeListen.shortName()}`

  if(lastFetchUrl === fetchUrl && !cacheBust) {
    buildData = lastFetchData;
  }
  else {
    const { data } = await get(fetchUrl)
    .catch((response) => {
      throw new Error(response.message);
    });

    buildData = lastFetchData = data;
    lastFetchUrl = fetchUrl;
  }

  

  return buildData || initialState

});

export const buildSlice = createSlice({
  name: "build",
  initialState,
  reducers: {
    setBuild: (state, action) => {
      state.build = action.payload;
    },
    resetBuild: (state) => {
      state.build = initialBuildState;
      state.status = SliceStatus.initial;
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchBuild.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchBuild.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = SliceStatus.succeeded;
          state.build = action.payload as IBuild;
          state.error = undefined;
        }
      })
      .addCase(fetchBuild.rejected, (state, action) => {
        state.status = SliceStatus.failed;
        state.build = initialBuildState;
        state.error = action.error.message;
      });
  },
});

// Export reset reducer
export const { setBuild, resetBuild } = buildSlice.actions;

// Action creators are generated for each case reducer function
export default buildSlice.reducer;
